exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Header_header_3pFnF {\n    display: flex;\n    justify-content: space-between;\n    background: #333;\n    color: white;\n    padding: 7px 5%;\n}\n\n.Header_contact_i9XuX {\n    display: flex;\n}\n\n.Header_tel_3V8eD,\n.Header_mail_1NHqA {\n    display: flex;\n    margin: 0% 2%;\n    text-align: center;\n    vertical-align: middle;\n    width: 200px;\n    align-items: center;\n}\n\n.Header_tel_3V8eD p,\n.Header_mail_1NHqA p {\n    /*margin-left: 5px;*/\n    margin: 0 5px;\n    vertical-align: middle;\n}\n\n.Header_socialNetwork_KyqRr {\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.Header_socialNetwork_KyqRr a,\n.Header_socialNetwork_KyqRr i {\n    margin: 2%;\n    color: white;\n}\n\n@media only screen and (max-width: 767px) {\n    .Header_contact_i9XuX {\n        display: none;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"header": "Header_header_3pFnF",
	"contact": "Header_contact_i9XuX",
	"tel": "Header_tel_3V8eD",
	"mail": "Header_mail_1NHqA",
	"socialNetwork": "Header_socialNetwork_KyqRr"
};